import { useState, useEffect, useRef } from "react";
import "./HeadlineArea.css";
import { Link } from "react-router-dom";

const carouselData = [
  {
    id: 1,
    subHeadline: "출판은 ‘가능성’이 아니라 ‘전문성’으로 완성됩니다",
    mainHeadline: "당신의 이름으로 \n출간되는 단 하나의 책!",
    description:
      "30년 경력의 에이콘이\n 당신의 첫 책을 가장 좋은 방식으로 세상에 내놓습니다.",
    image: "./images/Cat_On_Books_Headline_Area.png",
    alt: "Sleeping cat on books",
    bgColor: "#cfe2f3",
  },
  {
    id: 2,
    subHeadline: "디자인 & 브랜딩 서비스",
    mainHeadline: "독자의 시선을 사로잡는\n매력적인 북커버 디자인",
    description:
      "전문 디자이너 팀이 당신의 책에 꼭 맞는 옷을 입혀드립니다.\n첫인상부터 베스트셀러의 감성을 전달하세요.",
    image: "./images/Cat_On_Books_Headline_Area.png",
    alt: "Cat reading a book",
    bgColor: "#f7e6c3",
  },
  {
    id: 3,
    subHeadline: "글로벌 마케팅 지원",
    mainHeadline: "국내를 넘어 전 세계\n독자들과 만나보세요",
    description:
      "아마존, 구글 북스 등 글로벌 플랫폼 유통을 지원합니다.\n번역 및 현지화 마케팅으로 당신의 책을 세계에 알리세요.",
    image: "./images/Cat_On_Books_Headline_Area.png",
    alt: "Cat with a globe",
    bgColor: "#ffe0da",
  },
];

const HeadlineArea = () => {
  const intervalRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalItems = carouselData.length;

  const handlePrev = () => {
    const newIndex =
      (currentIndex - 1 + carouselData.length) % carouselData.length;
    setCurrentIndex(newIndex);
    startAutoSlide(); // 인터벌 초기화
  };

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % carouselData.length;
    setCurrentIndex(newIndex);
    startAutoSlide(); // 인터벌 초기화
  };

  // 자동 전환 useEffect 추가
  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % totalItems;
        return nextIndex;
      });
    }, 8000);
  };

  useEffect(() => {
    startAutoSlide();
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [totalItems]);

  return (
    <section className="home-headline-section">
      <div className="carousel-wrapper">
        {carouselData.map((slide, index) => {
          let itemClass = "carousel-slide";

          if (index === currentIndex) {
            itemClass += " active";
          } else if (index === (currentIndex - 1 + totalItems) % totalItems) {
            itemClass += " prev";
          } else if (index === (currentIndex + 1) % totalItems) {
            itemClass += " next";
          }

          return (
            <div className={itemClass} key={slide.id}>
              <div
                className="home-headline-section-content"
                style={{ backgroundColor: slide.bgColor }}
              >
                <h2 className="sub-headline">{slide.subHeadline}</h2>
                <h1 className="main-headline">{slide.mainHeadline}</h1>
                <p className="description-text">{slide.description}</p>
                <Link to="/get-started">
                  <button className="consultation-button">
                    출판 상담 신청하기 <span className="arrow-icon">→</span>
                  </button>
                </Link>
                <img
                  src={slide.image}
                  alt={slide.alt}
                  className="cat-illustration"
                />
              </div>
            </div>
          );
        })}
      </div>
      <button
        onClick={handlePrev}
        className="carousel-nav-button prev"
        aria-label="Previous slide"
      >
        <img
          src="./images/gray-arrow-down.png"
          style={{
            transform: "rotate(90deg)",
            width: "16px",
            height: "16px",
            filter:
              "brightness(0) saturate(100%) invert(62%) sepia(2%) saturate(2531%) hue-rotate(169deg) brightness(92%) contrast(91%)",
          }}
        ></img>
      </button>
      <button
        onClick={handleNext}
        className="carousel-nav-button next"
        aria-label="Next slide"
      >
        <img
          src="./images/gray-arrow-down.png"
          style={{
            transform: "rotate(270deg)",
            width: "16px",
            height: "16px",
            filter:
              "brightness(0) saturate(100%) invert(62%) sepia(2%) saturate(2531%) hue-rotate(169deg) brightness(92%) contrast(91%)",
          }}
        ></img>
      </button>
    </section>
  );
};

export default HeadlineArea;
